import { ReactElement, useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';
import classnames from 'classnames';

const accordionItems = [
  {
    title: 'pillows',
  },
  {
    title: 'decorativePillows',
  },
  {
    title: 'linens',
  },
  {
    title: 'duvet',
  },
  {
    title: 'mattressToppers',
  },
];

const BeddingSection = (): ReactElement => {
  const { t: tBedding } = useTranslation('', { keyPrefix: '$pages.$home.$beddingSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.beddingSection' });
  const [active, setActive] = useState(0);

  return (
    <section className="base-section bedding-section hp-section">
      <div className="bedding-top">
        <div className="bedding-title">
          <h2>
            <Trans i18nKey="title" t={tBedding} components={{ strong: <strong /> }} />
          </h2>
          <Button href={tLink('bedding')}>{tBedding('shopBedding')}</Button>
        </div>
        <div className="bedding-top-text">
          <p>{tBedding('description')}</p>
        </div>
      </div>
      <div className="bedding-bottom">
        <picture>
          <img
            src="/images/homepage/renaissance-hotels-bedding.webp"
            alt={tBedding('title')}
            width={1600}
            height={989}
            loading="lazy"
            decoding="async"
            fetchPriority="low"
          />
        </picture>
        <div className="bedding-accordion">
          {accordionItems.map((item, index) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
              key={item.title}
              className={classnames(`bedding-accordion-item item${index + 1}`, {
                active: active === index,
              })}
              onClick={() => setActive(index)}
            >
              <h3>
                <em className={classnames('bedding-accordion-item-line', `n${index + 1}`)} />
                <span>{tBedding(item.title)}</span>
              </h3>
              <Link href={tLink(`${item.title}`)}>
                <p>{tBedding(`${item.title}Description`)}</p>
                <p className="shop-now">
                  <span>{tButton('shopNow')}</span>
                </p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeddingSection;
